module.exports = __webpack_public_path__ + "media/images/products/vip-background-mobile-945c81019c9419eb802988440c60cce6.png";